import { Component, OnInit, Input } from '@angular/core';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { NotificationsService } from 'src/app/services/notifications-services/notifications.service';

@Component({
  selector: 'app-account-info-card',
  templateUrl: './account-info-card.component.html',
  styleUrls: ['./account-info-card.component.scss']
})
export class AccountInfoCardComponent implements OnInit {

  @Input() userdata;
  fakePassword: string;

  constructor(private snackBarService: SnackBarService,
              private notificationsService: NotificationsService) {
    this.fakePassword = '1234567890';
  }

  ngOnInit() { }

  public showPassword() {
    this.snackBarService.open('Por favor, para realizar esta acción contacte con su administrador', 'error');
  }
}
